// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Settings_context} from '../settings_ctx';
import {Textarea} from './textarea';
import {Button} from './button';
import {use_translation_v} from './trans_v';

function process_html_lasses(html, process_class_name){
    return html.replace(/class\s*=\s*["']([^"']+)["']/g, (match, list)=>{
        let new_list = list.split(/\s+/).map(process_class_name).join(' ');
        return `class="${new_list}"`;
    });
}

interface I_html_props {
    html: string;
    html_translated?: boolean;
}

interface I_html_editor_props {
    value: I_html_props;
    on_change: (new_value: I_html_props)=>void;
    on_cancel: ()=>void;
}

export const Html = (props: I_html_props)=>{
    const {theme} = useContext(Settings_context);
    const {t} = use_translation_v({no_defaults: true});
    const view = useMemo(()=>{
        const tr = props.html_translated ? props.html : t(props.html || '');
        return process_html_lasses(tr, class_name=>{
            if (theme[class_name])
                return theme[class_name];
            return class_name;
        });
    }, [props.html]);
    return <div dangerouslySetInnerHTML={{__html: view}} />;
};

export const Html_editor = (props: I_html_editor_props)=>{
    const [value, set_value] = useState(props?.value?.html || '');
    useEffect(()=>{
        set_value(props?.value?.html);
    }, [props?.value?.html]);
    return <div>
      <Textarea value={value} on_change={set_value} placeholder='HTML Text'
        as_html/>
      <Button caption={'Save HTML'} size={'sm'} on_click={()=>{
        props.on_change({html: value});
      }}/>
      <Button caption={'Cancel'} size={'sm'} on_click={()=>props.on_cancel()}/>
    </div>;
};

